import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import type { ApiKey, ApiKeyCreateRequest } from '@/types/user';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  keyData: ApiKeyCreateRequest;
};

export const createApiKey = async (
  scope: RequestScope,
  { keyData }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<ApiKey>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<ApiKey>>('/organization/client', keyData, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
